module.exports = __webpack_public_path__ + "media/images/menu/dorado-f9c1a6a676b459e89d8e3ec8d81357bb.jpg";